import { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Grid, Paper } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import { UsersTable } from 'components/Tables';
import { useStyles } from './styles';
import { useStore } from '../../hooks/useRootStore';
import TableHeader from 'components/Headers/TableHeader';
import { useHistory } from 'react-router-dom';
import { handleCompanyUrl } from 'utils/organizationUtils';
const Users: FC = observer(() => {
  const classes = useStyles();
  const history = useHistory();
  const [page, setPage] = useState(0);
  const {
    ldapStore: { setUsersKeywordFilter, clearClickedUser },
  } = useStore();
  useEffect(() => {
    if (history.action === 'POP') {
      localStorage.removeItem('ClickedUser');
    }
    document.title = 'EasyIdentity: Users';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid item xs={12}>
      <Container maxWidth='xl' className={classes.container}>
        <Grid className={classes.infoContainer} container alignItems='stretch' justify='flex-end'>
          <TableHeader
            headerLabel='User'
            headerAction={() => {
              localStorage.removeItem('ClickedUser');
              clearClickedUser();
              history.push(handleCompanyUrl('/user/add'));
            }}
            headerChecked={true}
            headerIcon={<PersonIcon style={{ color: 'grey' }} />}
            searchAction={(query: any) => {
              setUsersKeywordFilter(query);
              setPage(0);
            }}
            hanleClicked={clearClickedUser}
            usersAction={true}
          />
        </Grid>
      </Container>
      <Container maxWidth='xl' className={classes.tableBox}>
        <Paper className={classes.paper}>
          <UsersTable page={page} setPage={setPage} />
        </Paper>
      </Container>
    </Grid>
  );
});

export default Users;
